module.exports = __webpack_public_path__ + "static/media/Icon_Percentage.0e1786e7.png";